import "./SetCode.css";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { UsersActiveRegister, UsersReSendCode } from "../../Api/Services";
import { toast } from "react-toastify";

function SetCode() {
  const [inputValue, setInputValue] = useState({});
  const [flagLoading, setFlagLoading] = useState(false);

  const navigate = useNavigate();

  const LoginCheck = async () => {
    let validation = true;
    if (inputValue.code === "") {
      toast.error(" کد را وارد نمایید ");
      validation = false;
    }
    if (validation) {
      setFlagLoading(true);
      try {
        const UsersRegisterData = await UsersActiveRegister(inputValue);
        if (UsersRegisterData.status && UsersRegisterData.status === 200) {
          toast.success("ثبت نام  با موفقیت انجام شد");
          localStorage.removeItem("Identity");
          localStorage.removeItem("Username");
          localStorage.removeItem("CompanyUserName");
          localStorage.removeItem("Token");
          navigate("/Login");
        }
      } catch (error) {
        console.error("Error during login:", error);
      } finally {
        setFlagLoading(false);
      }
    }
  };
  const SendAgain = async () => {
    setFlagLoading(true);
    try {
      const UsersReSendCodeData = await UsersReSendCode();
      if (UsersReSendCodeData.status && UsersReSendCodeData.status === 200) {
        toast.success(" عملیات  با موفقیت انجام شد");
      }
    } catch (error) {
      console.error("Error during login:", error);
    } finally {
      setFlagLoading(false);
    }
  };

  const loginByEnter = (e) => {
    if (e.key === "Enter") {
      LoginCheck();
    }
  };

  return (
    <>
      {flagLoading && (
        <div
          className="scopeLoading d-flex justify-content-center align-items-center"
          style={{ height: window.innerHeight }}
        >
          <div className="lds-facebook">
            <div />
            <div />
            <div />
          </div>
        </div>
      )}
      <div className={flagLoading ? "startLoading" : "stateLoading"}>
        <div className="d-flex justify-content-center align-items-center">
          <div id="loginForm">
            <h2 className="text-center w-100 mt-2">کد احراز حویت</h2>
            <div className="p-5" onKeyPress={loginByEnter}>
              <div className="d-flex justify-content-center mb-4">
                <input
                  className="loginInput"
                  type="text"
                  placeholder="کد"
                  value={inputValue.code}
                  onChange={(e) => {
                    setInputValue({
                      ...inputValue,
                      code: e.target.value,
                    });
                  }}
                />
              </div>
              <div className="d-flex justify-content-center">
                <button className="loginButton mt-3" onClick={LoginCheck}>
                  ثبت
                </button>
              </div>
              <div
                onClick={SendAgain}
                className="d-flex justify-content-center pt-2"
              >
                <span className="text-info pointer">ارسال مجدد کد</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default SetCode;
